:host{display:flex;flex-direction:column;padding:16px 8px;overflow-y:auto;overflow-x:hidden}span{color:#232426de}h3-point-color-settings{padding-top:16px}mat-divider:not(.color-divider){margin-bottom:16px}.color-divider{margin-top:16px}
/*# sourceMappingURL=view-settings3d.component.css.map */
